module.exports = __webpack_public_path__ + "img/_othercountry.01ec9a4f.png";